/*eslint-disable*/
export default async el => {
  let $product = $('.product-link')
  let mobileNav = document.querySelector('.mobile-nav-container')
  let desktopNav = document.querySelector('.lookbook-footer')
  let preview = document.querySelectorAll('.preview')
  let categories = document.querySelectorAll('.category')

  if ($product != null) {
    $product.each(async function () {
      await $.getJSON(`https://snowehome.com/products/${this.dataset.handle}.json`, (data) => {
        let imageId
        if (this.dataset.variant) {
          data.product.variants.forEach(variant => {
            if (this.dataset.variant == variant.id) {
              imageId = variant.image_id
              this.dataset.price = variant.price
            }
          })
          data.product.images.forEach(image => {
            if (imageId == image.id) {
              this.dataset.image = image.src
            }
          })
        }
        if (this.dataset.handle == data.product.handle) {
          this.dataset.name = data.product.title
          if (!this.dataset.variant) { this.dataset.image = data.product.image.src }
          if (!this.dataset.variant) { this.dataset.price = data.product.variants[0].price.replace('.00', '') }
          this.dataset.url = data.product.handle
          let content = $(this).find('.lookbook-tooltip-content')
          content.html(`
          <img src="${this.dataset.image}">
          <p>${this.dataset.name}</p>
          <p>$${this.dataset.price}</p>
          <a class="lookbook-cta" target="_blank" href="https://snowehome.com/products/${this.dataset.handle}">Shop Now</a>
        `)
        }
      }).fail((error) => console.log('error: ', error))
    })
  }
  $product.click(function (e) {
    const toolTips = document.querySelectorAll('.lookbook-tooltip')
    let current = e.target.closest('div').querySelector('.lookbook-tooltip')
    toolTips.forEach(tool => {
      if (tool !== current) {
        tool.classList.remove('show')
        tool.classList.add('hide')
      } else if (current.classList.contains('show')) {
        tool.classList.remove('show')
        tool.classList.add('hide')
      } else {
        tool.classList.remove('hide')
        tool.classList.add('show')
      }
    })
    e.stopPropagation()
  })

  $(document).on('click', e => {
    if (!$(e.target).hasClass('.lookbook-tooltip') && !$(e.target).hasClass('.lookbook-tooltip-content')) {
      $('.lookbook-tooltip').addClass('hide').removeClass('show')
    }
  })
  $('.mobile-nav').click(function (e) {
    if (!$('.mobile-nav-container').hasClass('active')) {
      $('.mobile-nav-container').css('display', 'flex')
      $('.mobile-nav-container').addClass('active')
    } else {
      setTimeout(() => {
        $('.mobile-nav-container').css('display', 'none')
        $('.mobile-nav-container').removeClass('active')
      }, 0)
    }
    $('.mobile-nav-link').click(function (e) {
      setTimeout(() => {
        $('.mobile-nav-container').css('display', 'none')
        $('.mobile-nav-container').removeClass('active')
      }, 1000)
    })
  })

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.50
  }
  let scrollTarget = document.querySelector('.lookbook-container')
  let observer = new IntersectionObserver(changeNavColorCallback, options)
  scrollTarget.querySelectorAll('section').forEach(elem => observer.observe(elem))

  function changeNavColorCallback (element) {
    element.forEach(elem => {
      if (elem.isIntersecting && elem.target.id === 'spa-style') {
        desktopNav.style.backgroundColor = '#344c69'
        mobileNav.style.backgroundColor = '#344c69'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#344c69'
        })
        categories.forEach(category => {
          if (category.classList.contains('spa')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      } else if (elem.isIntersecting && elem.target.id === 'party-provisions') {
        desktopNav.style.backgroundColor = '#53242A'
        mobileNav.style.backgroundColor = '#53242A'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#53242A'
        })
        categories.forEach(category => {
          if (category.classList.contains('party')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      } else if (elem.isIntersecting && elem.target.id === 'sleep-over') {
        desktopNav.style.backgroundColor = '#3c4c3a'
        mobileNav.style.backgroundColor = '#3c4c3a'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#3c4c3a'
        })
        categories.forEach(category => {
          if (category.classList.contains('sleep')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      } else if (elem.isIntersecting && elem.target.id === 'into-the-night') {
        desktopNav.style.backgroundColor = '#ab6a5f'
        mobileNav.style.backgroundColor = '#ab6a5f'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#ab6a5f'
        })
        categories.forEach(category => {
          if (category.classList.contains('night')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      } else if (elem.isIntersecting && elem.target.id === 'your-own-oasis') {
        desktopNav.style.backgroundColor = '#b1997e'
        mobileNav.style.backgroundColor = '#b1997e'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#b1997e'
        })
        categories.forEach(category => {
          if (category.classList.contains('oasis')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      } else if (elem.isIntersecting && elem.target.id === 'a-final-toast') {
        desktopNav.style.backgroundColor = '#473b34'
        mobileNav.style.backgroundColor = '#473b34'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#473b34'
        })
        categories.forEach(category => {
          if (category.classList.contains('toast')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      } else if (elem.isIntersecting && elem.target.id === 'the-main-event') {
        desktopNav.style.backgroundColor = '#916434'
        mobileNav.style.backgroundColor = '#916434'
        $('.lookbook-tooltip').addClass('hide').removeClass('show')
        preview.forEach(preview => {
          preview.style.backgroundColor = '#916434'
        })
        categories.forEach(category => {
          if (category.classList.contains('main')) {
            category.classList.add('active-category')
          } else {
            category.classList.remove('active-category')
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/hosting-lookbook.js